import { ApiPaths } from 'api/constants';
import { TenantGeneral } from 'api/endpoints/tenants';
import {
  GetEndpointsResult,
  TmsConnectionDetails,
  ValidateTmsCredentials,
  ValidateTmsCredentialsResult,
} from 'api/endpoints/tmsConnections';
import ApiUrlParams from 'constants/apiUrlParams';
import BaseRepo from 'container/BaseRepo';
import { ApiResponseAsync } from 'container/models';

import { ITmsConnectionRepo } from './ITmsConnection';

export class TmsConnectionRepo extends BaseRepo implements ITmsConnectionRepo {
  getConnections = (): ApiResponseAsync<DataWithTotal<TmsConnectionDetails>> =>
    this.helpers.handleGet(ApiPaths.tmsConnections._());
  addConnection = (
    config: ValidateTmsCredentials
  ): ApiResponseAsync<TenantGeneral> =>
    this.helpers.handlePost(ApiPaths.tmsConnections._(), config);
  updateConnection = (
    connection: TmsConnectionDetails,
    config: ValidateTmsCredentials
  ): ApiResponseAsync<TenantGeneral> =>
    this.helpers.handlePut(
      ApiPaths.tmsConnections.byId._({
        [ApiUrlParams.tmsConnectionId]: connection.id,
      }),
      config
    );
  deleteConnection = (
    connection: TmsConnectionDetails
  ): ApiResponseAsync<void> =>
    this.helpers.handleDelete(
      ApiPaths.tmsConnections.byId._({
        [ApiUrlParams.tmsConnectionId]: connection.id,
      })
    );
  getConnectionDetails = (
    connection: TmsConnectionDetails
  ): ApiResponseAsync<TmsConnectionDetails> =>
    this.helpers.handleGet(
      ApiPaths.tmsConnections.byId._({
        [ApiUrlParams.tmsConnectionId]: connection.id,
      })
    );
  validateCredentials = (
    config: ValidateTmsCredentials
  ): ApiResponseAsync<ValidateTmsCredentialsResult> =>
    this.helpers.handlePost(
      ApiPaths.tmsConnections.validateCredentials._(),
      config
    );
  getEndpoints = (type: string): ApiResponseAsync<GetEndpointsResult> => {
    throw new Error('Method not implemented.');
  };
}
